module.exports = __webpack_public_path__ + "0b1ca148890222235a0f9903636ca21a.png";